import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { SessionStorageService } from "../../../../shared/services/storage/session-storage.service";
import { SearchTableService } from "../../../../shared/services/table-column-mapping/search-table.service";
import { HttpClient } from "@angular/common/http";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { Router } from "@angular/router";
import _ from "underscore";
import { SearchContainerHeight } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { MapSearchService } from "../../../../shared/services/map-search/map-search.service";
import { PoiSearchOption } from "../enums/poi-search-enum";
import GeometryUtils from "../../../../shared/utils/geometry-utils";
let PoiSearchService = class PoiSearchService extends MapSearchService {
    sessionStorageService;
    searchTableService;
    http;
    requestStatusService;
    router;
    poiUrl;
    poiSearchType;
    arcGisPoiOutColumnList;
    // @ts-ignore
    arcGisPropertyOutColumnList;
    poiList = new BehaviorSubject(null);
    poiListAsObservable = this.poiList.asObservable();
    poiSearchTableColumnMap = new BehaviorSubject(null);
    poiSearchTableColumnMapObservable = this.poiSearchTableColumnMap.asObservable();
    searchOptionsMap;
    selectedSearchOptionLookup;
    constructor(sessionStorageService, searchTableService, http, requestStatusService, router) {
        super(sessionStorageService, searchTableService);
        this.sessionStorageService = sessionStorageService;
        this.searchTableService = searchTableService;
        this.http = http;
        this.requestStatusService = requestStatusService;
        this.router = router;
        this.mapLocationAsObservable = this.mapLocation.asObservable();
    }
    setPOIList(POIsFound) {
        this.poiList.next(POIsFound);
    }
    clearURLList() {
        this.poiUrl = "";
    }
    setURL(searchType, url) {
        switch (searchType) {
            case PoiSearchOption.Poi:
                this.poiUrl = url;
                break;
        }
    }
    setSearchOptionLookup(searchEnum) {
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(searchEnum)) {
            // @ts-ignore
            this.searchOptionsMap.set(key, value);
        }
    }
    setSelectedSearchOption(searchOption) {
        this.selectedSearchOptionLookup = this.getSearchOptionLookup(searchOption);
        this.poiSearchType = PoiSearchOption.Poi;
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    setTableColumnMap(tableColumnMap) {
        this.poiSearchTableColumnMap.next(tableColumnMap);
    }
    clearTableColumnMap() {
        this.poiSearchTableColumnMap.next(new Map());
    }
    getLayerUrl(searchType) {
        switch (searchType) {
            case PoiSearchOption.Poi:
                return this.poiUrl;
            default:
                return this.poiUrl;
        }
    }
    // @ts-ignore
    transformFeature(feature, searchOption) {
        switch (searchOption ? searchOption : this.poiSearchType) {
            case PoiSearchOption.Poi:
                return {
                    id: feature.attributes.OBJECTID ? feature.attributes.OBJECTID : (feature.attributes.objectid ? feature.attributes.objectid : null),
                    name: feature.attributes.Name ? feature.attributes.Name : (feature.attributes.name ? feature.attributes.name : null),
                    alternativeName: feature.attributes.AlternativeName ? feature.attributes.AlternativeName : (feature.attributes.alternativename ? feature.attributes.alternativename : null),
                    address: feature.attributes.Address ? feature.attributes.Address : (feature.attributes.address ? feature.attributes.address : null),
                    type: feature.attributes.Type ? feature.attributes.Type : (feature.attributes.type ? feature.attributes.type : null),
                    ward: feature.attributes.Ward ? feature.attributes.Ward : (feature.attributes.ward ? feature.attributes.ward : null),
                    geometry: feature.geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : (feature.attributes.Geometry ? GeometryUtils.mapGeometryToDTO(feature.geometry) : null)
                };
        }
    }
    getAttributeListForSearchType(searchOption) {
        switch (searchOption) {
            case PoiSearchOption.Poi:
                return [..._.values(this.arcGisPoiOutColumnList)];
        }
    }
    // build links for map locator and create application request
    addMapLocatorLinks(poisFound) {
        poisFound.forEach(poi => {
            poi.link = this.setMapLink(poi, SearchContainerHeight.POILocationMap);
        });
        this.setPOIList(poisFound);
    }
    setMapLink(poi, height) {
        return {
            text: SharedConstants.VIEW_ON_MAP_TEXT,
            address: "",
            clickAction: (link) => {
                this.changeMapLocation(String(poi.id), height);
            }
        };
    }
    // setCreateApplicationLink(property) {
    //   return {
    //     text: SharedConstants.CREATE_APPLICATION_TEXT,
    //     address: "",
    //     clickAction: (link: ILink) => {
    //       this.startApplicationSelectedProperty(property);
    //     }
    //   };
    // }
    clearPOIsList() {
        this.poiList.next([]);
    }
    setCreateApplicationLink(poi) {
        return undefined;
    }
    startApplicationSelectedProperty(property) {
        const url = this.getLayerUrl(PoiSearchOption.Poi);
        // @ts-ignore
        this.doSearch(url, property.id.toString(), ArcGisPColumn.Id, true, PoiSearchOption.Poi, true, true).then((result) => {
            if (result.length > 0) {
                this.router.navigate([this.getStartApplicationRoute()], { state: { propertyData: JSON.stringify(result[0]) } }).then();
            }
        });
    }
    getStartApplicationRoute() {
    }
    static ctorParameters = () => [
        { type: SessionStorageService },
        { type: SearchTableService },
        { type: HttpClient },
        { type: RequestStatusService },
        { type: Router }
    ];
};
PoiSearchService = __decorate([
    Injectable({
        providedIn: "root"
    })
], PoiSearchService);
export { PoiSearchService };
